export default {
  text: {
    meta_0: '提高全局等级。 解锁新功能。 请参阅功能列表中的要求。',
    meta_1: '扩大资源容量。 购买更大的升级。 避免资源浪费。',
    meta_2: '你想什么时候离开就什么时候离开。 这里的一切都在继续运转。',
    meta_3: '多种功能。 所有人同时继续工作。',
    meta_4: '不要忽视功能。 一切都重要。',
    meta_5: '全局等级。 需要解锁新功能。 进步功能增加。',
    meta_6: {
      title: '备份你的存档文件!',
      text: '基于浏览器的保存文件并不完全可靠，因此请经常备份您的保存文件！ 只需一次小事故就足以抹去您的进度，例如浏览器崩溃、断电、浏览器将游戏误认为是跟踪器或游戏中的错误。 每当出现提示以及发布新更新时下载备份，这样您就安全了。 iOS 用户和 itch 玩家保存文件丢失的风险较高，应将备份提示更改为“常见”',
    },
    meta_7: {
      title: '工具提示',
      text: '如果您将鼠标悬停在游戏中的许多元素上，它们会显示附加信息。 移动设备上的玩家可以点击并按住以获得相同的结果',
      buttonTooltip: '点击切换',
    },

    mining_0: '使用镐子。 挖得更深一些',
    mining_1: '收集废料。 购买升级。',
    mining_2: '达到新的深度。 解锁新的升级。',
    mining_3: '请查看设置。 可以自动化往下挖。',
    mining_4: '提取矿石。 购买更多升级。',
    mining_5: '挖得更深一些。 寻找更多矿石。',
    mining_6: '购买制作站。 制作更好的镐。',
    mining_7: '继续制作。 有时很好。 有时不好。',
    mining_8: '更多插槽。 更好的镐。 压缩矿石。 需要更多或。 坏镐少一些。',
    mining_9: '新矿石。 将两者用于手工制作。 是最好的结果。',
    mining_10: '挖得更深一些。 寻找其他矿石。',
    mining_11: '降低韧性。 进一步前进。',
    mining_12: '解锁居住者。 为新的周期做好准备。 不过还需要时间。',
    mining_13:
      '挖得太深了。 一些矿石消失了。 需要特定的深度。 然后它们就回来了。',
    mining_14: '新矿石。 另一个。 新矿石更好。 但不纯。',
    mining_15: '敲击同一块岩石 1000 次。 在 50m 或更深处。 寻找新的东西。',
    mining_16: '现在的坑真的好深啊。千万不要掉进去。这可能会杀死你。',
    mining_17: '一个洞。 一块石头。',
    mining_18: '找到了冶炼厂。 很热。 需要矿石。 还有新材料。 但效果不错。',
    mining_19: '铜也不见了。 不用担心。 它会回来。 也许。',
    mining_20: '另一种稀土。 每个人都有自己的条件。 并使用。',
    mining_21: '下一个矿石。 这次是铁。 很不纯洁。 需要大量压缩。',
    mining_22: '发现煤了。 不是矿石。 不能用于制作。 没有升级。 煤没啥用？',
    mining_23: '煤有用。 特殊升级。 改善伤害。 或绿色水晶。',
    mining_24: '洞太深了。 看不到底部。 只有黑暗。',
    mining_25: '新的增强。 需要10金属锭。 让镐变得更好。',
    mining_26: '另一种矿石。 现在正常了。 用于制作。 需要大量的纯度。',
    mining_27: '锻造余烬。 获取下一个周期。 那么有用。 使冶炼速度更快。',
    mining_28: '继续锻造金属条。 给予不同的增强。',
    mining_29: '使用余烬。 损失冶炼速度。 考虑一下选择。',
    mining_30:
      '找到了树脂。 从树上。 让镐变得更好。 但需要很长时间才能得到。 好几个小时。',
    mining_31: '不要滴下树脂。 坚持一切。 在那里待几天。',
    mining_32:
      '想知道树是如何生存的。 漆黑的山洞。 环境不理想。 但仍然在增长。',
    mining_33: '现在最后一个注意事项。 纸用完了。 或许会回来。 并多写一些。',

    village_0: '孤独的生物。 派出去做收集工作吧。',
    village_1: '建造棚屋。 吸引更多的生物。',
    village_2: '生物看起来很奇怪。 棕色且多毛。',
    village_3: '宁静的农场。 庄稼生长。 生产食物。',
    village_4: '果树。 也生产食物。',
    village_5: '黑暗的我很可怕。 但给金属。',
    village_6: '生物现在组建了社区。 跳舞庆祝。',
    village_7: '对房子不熟悉的生物。 还有门。 但很喜欢。',
    village_8: '存储非常重要。 往往是容量问题。 不是价格。',
    village_9: '劳动生物缴纳税款。 消耗食物。 给硬币。',
    village_10: '盯着硬币的生物。 一定要保管好硬币。 在安全的地方。',
    village_11: '生物从洞里取水。 用手臂抓住水桶。 与水。',
    village_12: '漂亮的花。 生物似乎并不关心。 但还是很漂亮。',
    village_13: '生物之城。 他们又跳舞了。 看来对他们来说很重要。',
    village_14: '生物已经习惯了居住。 打开窗口。 是灿烂的笑容。',
    village_15: '生物都很聪明。 没想到。 只能说唉。',
    village_16: '鱼看起来很漂亮。 想吃它们。 但是不可以。 不是现在。',
    village_17: '闻沙子的味道。 可以定型。 危险的工作。',
    village_18: '生物们都相信。 在世界的尽头。 在重生之中。',
    village_19: '巨大的塔。 满是书。 还有纸。 生物看着它。 带着钦佩。',
    village_20:
      '生物似乎持怀疑态度。 不喜欢这个。 贴上“没有家庭作业”的牌子。 生物会改变主意。',
    village_21: '自己的政府。 他们又跳舞了。 但不是所有的。 有些担心。',
    village_22: '强大的方尖碑。 令人生畏的尺寸。 海量存储。',
    village_23: '生物相信。 不仅是重生。 亦于牺牲。',
    village_24: '生物生活得很好。 担心娱乐。 不是食物。',
    village_25: '更锋利的斧子。 砍伐硬木。 还有普通的木头。',
    village_26: '当心。 爆炸危险。',
    village_27: '生物真的生活得很好。 买得起奢侈品。',
    village_28: '令人放松的湖。 满满的都是鱼。',
    village_29: '知识丢失了。 随着时间的推移。 再次发现它。',
    village_30: '小生物。 喜欢这个。',
    village_31: {
      title: '移动队列元素',
      text: '您可以通过拖动元素来更改构建队列中元素的顺序',
    },

    horde_0:
      '成群的怪物。 阻塞路径。 只有一种方法可以前进。 杀够了。 然后杀掉首领。',
    horde_1: '一组死了。 但更多的出现。',
    horde_2: '进一步前进。 获取更多骨头。',
    horde_3: '装备物品。 改善属性。 在战斗中使用技能。',
    horde_4: '与怪物战斗。 寻找新装备。',
    horde_5: '在更高的区域战斗。 寻找更好的装备。 发现几率也更高。',
    horde_6: '到达区域 10。击败所有敌人。 寻找新货币。',
    horde_7: '怪物看起来很可怕。 不用担心。 总会重生。',
    horde_8: '看不到尽头。 怪物无处不在。',
    horde_9: '怪物变得更强。 但可以预见。',
    horde_10: '奇怪的灵魂。 已损坏且无法使用。 需要净化。',
    horde_11: '可以得到灵魂。 每个小Boss。 总能得到。',
    horde_12: '更高的区域Boss。 容纳更多的灵魂。 还得到更多。',
    horde_13: '关心印记。 有时候换装备也不错。',
    horde_14: '杀死小Boss。 寻找传家宝。 属于他们。 现在可以帮助你了。 永远。',
    horde_15: '更高区域。 更多印记。 无论是数量还是种类。',
    horde_16: '所以它开始了。 腐败使他们更强大。',
    horde_17: '获取净化器。 打败腐败。',
    horde_18: '获得腐化的肉体。 随着时间的推移慢慢的。 减少腐败。',
    horde_19: '更高区域。 寻找不同的传家宝。',
    horde_20: '大集合。 装备方面。 尝试哪个最好。',
    horde_21: '腐败危险。 别让它变大。 不仅仅是攻击和生命值。',
    horde_22: '灰烬圈。 有助于反腐败。',
    horde_23: '发现更多。 更多的装备。 更多传家宝。 更多印记。',
    horde_24: '击败Boss。 有装备。 获得精通。',
    horde_25: '更好的装备. 需要更高的区域Boss。 为了精通。',
    horde_26: '精通不错。 解锁改良。 对于装备。',
    horde_27: '改良传家宝。 全部。',
    horde_28: '纸张不足。 需要得到更多。',
    horde_29: '寻找更多传家宝。 立刻。 很强大。',
    horde_30: '没有纸了。 必须回来。 还有更多要说的。',

    farm_0: '种植胡萝卜。 等待。 然后收获。',
    farm_1: '获取蔬菜。 购买其他种子。',
    farm_2: '不同的作物类型。 不同的收获。 都需要它们。',
    farm_3: '农作物长得太茂盛。 倍增收获。 需要升级。',
    farm_4: '解锁更多地块。 多种植一些。',
    farm_5: '获取侏儒。 放置在农场。 寻找稀有货币。',
    farm_6: '收获特定作物。 获得稀有掉落物。',
    farm_7: '小心容量。 稀有掉落的硬性限制。',
    farm_8: '放置洒水装置。 行生长得更快。',
    farm_9: '花瓣特殊。 提高花卉产量。 囤积它们。',
    farm_10: '虫子真恶心。 没有人喜欢他们。 不幸的是仍然需要。',
    farm_11: '美丽的翅膀。 就像脆弱的小鸟。',
    farm_12: '讲台不错。 放好它。 整列作物三倍经验。',
    farm_13: '虫子很臭。 为什么要用它来制作香水？ 为什么？？？ 糟糕的主意！',
    farm_14: '幸运的小虫子。 也不臭。 看起来不错。',
    farm_15: '农场很安静。 几乎忘记了部落的大规模屠杀。',
    farm_16: '花园里的猎人。 控制虫子。',
    farm_17:
      '风车有趣。 在附近放置独特的农作物。 风车周围有8个点。 寻找更多黄金。 整个农场上。',
    farm_18: '更多肥料。 更多花费黄金和宝石的方式。',
    farm_19: '小蜜蜂。 一直在工作。 而且数量众多。',
    farm_20: '旗帜复杂。 改良某种作物。 类型取决于位置。 最好看一下说明书。',
    farm_21: '金玫瑰。 拥有罕见的花瓣。 非常有价值。',

    gallery_0: '玩转颜色。 作画。 远大的梦想。',
    gallery_1: '不断尝试。 尝试新的。 让你变得更好。',
    gallery_2: '回收旧纸。 换成新的东西。 色彩缤纷的东西。',
    gallery_3: '转换成更多。 以同样的成本。 总是有用的。',
    gallery_4: '过滤旧纸。 回收之前。 得到更多。',
    gallery_5: '思考。 获得新想法。 保留好的。 打造自己的风格。',
    gallery_6: '旧垃圾桶。 臭。 但很有用。',
    gallery_7: '更好的绘画工具。 更好的结果。 更加丰富多彩。',
    gallery_8: '出卖你的辛勤劳动。 钱会有用的。',
    gallery_9: '获取鼓。 需要包。 还有运气。 但很值得。',

    gem_0: '生成宝石。 需要时间。 购买高级升级。',
    gem_1: '要有耐心。 考虑购买。 宝石需要很长时间才能获得。',

    achievement_0: '达到目标。 获得成就。 更快地生成宝石。',

    school_0: '在学校学习。 正确回答。 取得好成绩。',
    school_1: '做一个热心的学生。 获得金粉。 可以跳过时间。',
    school_2: '获取新书。 每隔一小时。 主题越多，效果就越好。',
    school_3: '还要学写字。 获取更多书籍。',
    school_4: '历史很重要。 记住日期。 甚至更多的书。',

    relic_0: '获取圣遗物。 永远有帮助。',

    card_0: '购买卡包。 收集卡片。 获得奖励。',
    card_1: '完成卡片收集。 获得更多奖励。',

    event_0: '参加活动。 时间有限。 获得奖励。',
    event_1: '大活动。 获取活动代币的进度。 然后用它们换取奖励。',
    event_2:
      '将黄玉用于有用的升级。 但不要在大型活动期间获得黄玉。 换成其他货币。',
    event_3: '购买特殊物品。 使用黄玉。',
    event_4:
      '玩宾果游戏。 获得一个或多个宾果游戏的奖励。 获得一定数量还可获得奖励。',
    event_5: '旋转轮子。 得到奖励。',
    event_6:
      '三个选择之一。 保存以永久升级。 投资黄玉以获得利息。 借用黄玉并稍后偿还。',
    event_7: '购买生产商。 获得光线。',
    event_8: '购买足够的生产商。 获得特殊升级。',
    event_9: '购买蜡烛。 获得更多光线。 还可以获得烟灰进行特殊升级。',
    event_10: '获得足够的光线。 接收代币作为奖励。',
    event_11: '将花拖至饲养员处。 随着时间的推移，获得更多的花朵。',
    event_12: '合并两朵花。 同级别的。 买一个更好的。',
    event_13: '卖花。 为了开花。 购买升级。',
    event_14: '达到更高的鲜花等级。 接收代币作为奖励。',
    event_15: '要有耐心。 随着时间的推移，可以钓到鱼。 或者其他的事情。',
    event_16: '看鱼。 每个人都有自己的条件。',
    event_17: '新地点。 新鱼。 以及其他变化。',
    event_18: '钓到最大的鱼。 接收新尺寸记录的代币。',
    event_19: '盛大的夏日祭典。 建造建筑物。 完成任务。',
    event_20:
      '收集器很有帮助。 自动收集附近图块上的资源。 不过要小心。 放置它的方块图块。 像所有建筑物一样。',
    event_21: '不要因为破坏建筑物而感到难过。 空间有限。',
    event_22: '主舞台很重要。 解锁新建筑。 甚至可以在之后被摧毁。',
    event_23:
      '完成更多任务。 接收更多瓷砖。 可以选择拥有哪一个。 但需要与现有的连接。',
    event_24: '有些建筑物可以处理。 选择建筑物并选择配方。',
    event_25: '完成任务。 接收代币作为奖励。 但需要资源。',
    event_26:
      '关注货币。 当它们看起来不寻常时，将鼠标悬停在它们上方以查找成分。',
    event_27: '使用成分。 进行仪式。',
    event_28:
      '寻找新药水。 获得精华。 再次执行相同的仪式以提高药水等级。 并获得更多代币。',
    event_29: '成功的仪式。 接收代币作为奖励。 尝试不同的成分以获得更多效果。',
    event_30: '开始打雪仗。 需要滚雪球。 获胜即可获得有用的物品。',
    event_31: '宠物很有帮助。 还扔雪球。 但比玩家弱。',
    event_32: '谨慎选择物品。 可以改变。 但需要滚雪球。',
    event_33: '赢得战斗。 接收代币作为奖励。 还有雪球。',

    treasure_0: '购买宝藏。 提供有益的效果。',
    treasure_1: '打碎宝藏。 效果没了。 但获得碎片。',
    treasure_2: '使用碎片。 升级宝藏。 效果更好。',

    cryolab_0: '冷冻功能。 被动获得声望货币。',
    cryolab_1:
      '升级功能。 获得更多声望货币。 还可以被动获得一点声望货币。 即使没有冷冻。',

    general_0: '做任务。 接收更多笔记。 完成后获得遗物。',
    general_1:
      '很高兴看到您对我们的信号作出回应。 我叫格罗博达尔，我来这里是为了向您展示我们奇妙的世界。',
    general_2:
      '很高兴看到这个古老的定居点再次繁荣起来。 你似乎对这个世界产生了非常积极的影响，所以让我告诉你一些事情。 如果你住在矿井深处，你就能找到对你的进步至关重要的东西。',
    general_3:
      '啊，老钻头。 我们曾经建造这些来探索我们世界的地下，但那是很久以前的事了。',
    general_4:
      '随着学校重新矗立，这些生物现在可以过上受教育的生活了。 既然已经解决了，来点挑战怎么样？ 如果你能在 15 分钟或更短的时间内获得 100 亿个废品，我就把这个旧时代的遗物送给你。',
    general_5:
      '你做到了，太棒了！ 正如我所承诺的，这是圣物。 这是一个非常古老的灯，我的祖先用它们来照亮洞穴系统。 我相信你能找到它的用处。',
    general_6:
      '因此，即使在这种危险的环境中，你也能毫无问题地取得进步。 我希望我的笔记对此有所帮助，尽管我的笔迹有时很难辨认。 不管怎样，来点小挑战怎么样？ 您认为在不离开第一个区域的情况下可以累计 50 亿伤害吗？',
    general_7:
      '看来这对你来说根本不是一个挑战。 那么再换一个怎么样？ 制作镐是在矿井中前进的重要组成部分，您认为在不制作一把镐的情况下您能走多远？ 40米对我来说听起来是可能的。',
    general_8:
      '探索地下的感觉真是棒极了。 我知道，因为我自己已经这样做了很长时间。 不过，我使用了自动钻机，因此仅用一把基本的镐就可以挖掘 40 米，这是一项令人印象深刻的壮举！',
    general_9:
      '小心腐败，乍一看似乎可以控制，但不要让它失控。 当敌人的腐败程度上升到更高的水平时，他们几乎变得不可战胜。',
    general_10:
      '有了自己的政府，这些生物应该能够自给自足。 但我认为他们仍然更喜欢你的指导，到目前为止效果很好。 但我们来谈谈别的事情吧。 要获得我的遗物，你需要积累大量的腐化灵魂。',
    general_11:
      '应该有足够多的灵魂来理解这个遗物的意义。 这是我们历史上一个非常重要时刻的心，当时我们不得不面对巨大的挑战。',
    general_12:
      '很高兴看到土豆又长出来了。 种子箱里似乎装着很多旧时代的种子。 我们应该把这些美丽的植物带到村庄里，也传播那里轻松的氛围。',
    general_13:
      '多次种植同一种作物，其等级就会提高。 从技术上讲，你可以在 4 级时获得声望，但这次尝试在农作物上达到 7 级。',
    general_14:
      '您的农场里的植物生长得非常好。 将它们种植在地下可能是一个相当大的挑战，并非所有类型的植物都对人造阳光有良好的反应。 你应该为肥沃的土壤和充足的阳光感到高兴。',
    general_15:
      '那庄稼的产量很大！ 有了这么大的产量，你应该可以毫无问题地解锁更多种子。 从种子箱中取出总共 7 粒种子，我会给你一颗曾经在我们星球上很常见的古老植物的遗物。',
    general_16:
      '这是榛子树上的腐烂叶子。 秋天的时候，这些树叶曾经到处都是。 也许您可以在农场中使用它，使土壤变得更加肥沃。 只要把它埋在你的农场下面，就可以了。',
    general_17:
      '您可能想知道为什么这里的一切都充满了废料。 这是一个关于有限世界中对资源的无限需求的说来话长的故事。',
    general_18:
      '当你耗尽资源时，你再强大也变得毫无意义。 学会用很少的资源茁壮成长，这是一项需要学习的重要技能。',
    general_19:
      '这个村庄的地下结构似乎与矿井不同。 干净的石头随处可见，没有一丝废料。',
    general_20:
      '这是一种可以轻松突破充满废料的地雷的专用工具。 我自己使用过其中一种，可以证实它们的有效性。',
    general_21:
      '精通你的装备可能需要很长时间，但这是值得的。 这个世界面临着严峻的挑战，你需要得到一切能得到的帮助。',
    general_22:
      '要种植如此巨大的植物，你必须了解这个世界并适应它。 这种态度会让你在我们的世界走得更远。',
    general_23:
      '即使在村庄里，你也能达到新的文明程度。 相信我，这些生物对此非常高兴。',
    general_24:
      '这些装备对你来说可能看起来很先进，但与我们现有的工具相比，这根本不算什么。 技术可以极大地改变游戏规则。',
    general_25:
      '这些挑战无疑是艰巨的，但你才刚刚开始。 如果您能够在不装备超过一件物品的情况下到达 110 区域，您可以获得一份小奖品。 只是为了让你保持动力。',
    general_26:
      '恭喜你，这绝对是你应得的！ 至此我可以自信地说 Gooboo 项目到目前为止是成功的!',
    general_27:
      '艺术，我已经很久没有见过的东西了。 并不是说我讨厌它，而是现在已经很长一段时间不需要实体装饰了。',
    general_28:
      '绿色，自然的颜色，生命的颜色。 在过去，植物是健康生态系统的标志。 一旦绿色消失，一切就开始走下坡路。',
    general_29:
      '幸运的是，我们现在不必担心植物。 我们是一个数字文明，我们的能源来源并非来自生物。',
    general_30:
      '过去，我们常常以巨额现金拍卖最美丽的艺术品。 也许，我们可以重现这个。 让我们看看这个旧花瓶能卖多少钱。',
    general_31:
      '那应该足够了！ 花瓶是你的，它对你来说应该比对我更有用。 只需将它放在您的画旁边，这应该有助于您的创造力。',
    general_32: '',
    general_33: '',
    general_34: '',
    general_35: '',
    general_36: '',
    general_37: '',
    general_38: '',
    general_39: '',
    general_40: '',
  },
  author: {
    g: 'G',
    grobodal: '格罗博达尔',
    orladee: '奥拉迪',
    oppenschroe: '奥本施罗',
    bellux: '贝卢克斯',
    onoclua: '奥诺克卢亚',
    omnisolix: '奥尼索利克斯',
  },
};
